import { render, staticRenderFns } from "./WillChildrenExcludedDetails.vue?vue&type=template&id=48e5f1f2"
import script from "./WillChildrenExcludedDetails.vue?vue&type=script&lang=js"
export * from "./WillChildrenExcludedDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports